// src/Pages/AdminManagment/EditUser.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
  FaArrowLeft, FaSave, FaSpinner, FaUser, FaEnvelope, FaPhone,
  FaVenusMars, FaCalendarAlt, FaMapMarkerAlt, FaBriefcase,
  FaGraduationCap, FaHeart, FaUsers, FaTree, FaTint, FaIdCard,
  FaUpload, FaTimes, FaCheckCircle, FaGlobe, FaCity, FaBuilding
} from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { successToast, errorToast } from '../../Utils/toast';
import { 
  useGetUserByIdQuery, 
  useUpdateUserProfileMutation
} from '../../redux/services/pariwarmember/pariwar.Services';

// ✅ NEW IMPORTS: GotraApi and WaadApi
import { useGetGotraQuery } from '../../redux/services/gotraService/gotra.Services';
import { 
  useGetWaadDropdownQuery, 
  useGetWaadWithGaonsQuery 
} from '../../redux/services/waadService/waad.Services';

function EditUser() {
  const { role, id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const isPariwar = role === '1';
  const isSadasya = role === '2';

  // ==========================================
  // ✅ 1. API HOOKS
  // ==========================================

  // User Data
  const { data: userData, isLoading: userLoading } = useGetUserByIdQuery(id, { skip: !id });
  
  // Gotra List
  const { data: gotraData, isLoading: gotraLoading } = useGetGotraQuery({ limit: 100 });

  // Waad Dropdown
  const { data: waadData, isLoading: waadLoading } = useGetWaadDropdownQuery();

  // Waad with Gaons (Dynamic - depends on selected Waad)
  const [selectedWaadId, setSelectedWaadId] = useState('');
  const { data: gaonData, isLoading: gaonLoading } = useGetWaadWithGaonsQuery(selectedWaadId, {
    skip: !selectedWaadId,
  });

  const [updateUser, { isLoading: isUpdating }] = useUpdateUserProfileMutation();

  // ==========================================
  // ✅ 2. FORM STATE
  // ==========================================
  const [form, setForm] = useState({
    name: '',
    father_name: '',
    mother_name: '',
    mother_gotra: '',
    dada_name: '',
    dadi_name: '',
    dadi_gotra: '',
    nana_name: '',
    nani_name: '',
    nani_gotra: '',
    self_gotra: '',
    rishi_pravar_gotra: '',
    sadasya_gotra: '',
    gender: '',
    dob: '',
    marrige_status: 'Unmarried',
    marrige_year: '',
    blood_group: '',
    mobile: '',
    wp_number: '',
    email: '',
    password: '',
    relations: 'Head',
    aadhar_number: '',
    education: '',
    business: '',
    job_position: '',
    department: '',
    posted_place: '',
    working_address: '',
    anual_income: '',
    country_id: '',
    country_name: '',
    state_id: '',
    state_name: '',
    city_id: '',
    city_name: '',
    waad_id: '',
    waad_name: '',
    gaon_id: '',
    gaon_name: '',
    tehsil_name: '',
    village_name: '',
    ward_name_number: '',
    pin_code: '',
    native_village: '',
    international_address: '',
    father_in_law_name: '',
    mother_in_law_name: '',
    husband_name: '',
    father_address: '',
  });

  // ==========================================
  // ✅ 3. LOAD DATA FROM API
  // ==========================================
  useEffect(() => {
    if (userData?.data) {
      const u = userData.data;
      
      const formatDate = (dateString) => {
        if (!dateString) return '';
        return dateString.split('T')[0];
      };

      setForm({
        name: u.name || '',
        father_name: u.father_name || '',
        mother_name: u.mother_name || '',
        mother_gotra: u.mother_gotra || '',
        dada_name: u.dada_name || '',
        dadi_name: u.dadi_name || '',
        dadi_gotra: u.dadi_gotra || '',
        nana_name: u.nana_name || '',
        nani_name: u.nani_name || '',
        nani_gotra: u.nani_gotra || '',
        self_gotra: u.self_gotra || '',
        rishi_pravar_gotra: u.rishi_pravar_gotra || '',
        sadasya_gotra: u.sadasya_gotra || '',
        gender: u.gender || '',
        dob: formatDate(u.dob),
        marrige_status: u.marrige_status || 'Unmarried',
        marrige_year: u.marrige_year ? u.marrige_year.split('T')[0].split('-')[0] : '',
        blood_group: u.blood_group || '',
        mobile: u.mobile || '',
        wp_number: u.wp_number || '',
        email: u.email || '',
        password: '',
        relations: u.relations || 'Head',
        aadhar_number: u.aadhar_number || '',
        education: u.education || '',
        business: u.business || '',
        job_position: u.job_position || '',
        department: u.department || '',
        posted_place: u.posted_place || '',
        working_address: u.working_address || '',
        anual_income: u.anual_income ? String(u.anual_income) : '',
        country_id: u.country_id || '',
        country_name: u.country_name || '',
        state_id: u.state_id || '',
        state_name: u.state_name || '',
        city_id: u.city_id || '',
        city_name: u.city_name || '',
        waad_id: u.waad_id || '',
        waad_name: u.waad_name || '',
        gaon_id: u.gaon_id || '',
        gaon_name: u.gaon_name || '',
        tehsil_name: u.tehsil_name || '',
        village_name: u.village_name || '',
        ward_name_number: u.ward_name_number || '',
        pin_code: u.pin_code || '',
        native_village: u.native_village || '',
        international_address: u.international_address || '',
        father_in_law_name: u.father_in_law_name || '',
        mother_in_law_name: u.mother_in_law_name || '',
        husband_name: u.husband_name || '',
        father_address: u.father_address || '',
      });

      // ✅ Set selected Waad ID for Gaon dropdown
      if (u.waad_id) {
        setSelectedWaadId(u.waad_id);
      }
    }
  }, [userData]);

  // ==========================================
  // ✅ 4. HANDLE CHANGE
  // ==========================================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    
    // ✅ If Waad changes, update Gaon dropdown
    if (name === 'waad_id') {
      setSelectedWaadId(value);
      setForm(prev => ({ ...prev, gaon_id: '', gaon_name: '' }));
    }
  };

  // ==========================================
  // ✅ 5. HANDLE SUBMIT
  // ==========================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.name.trim()) {
      errorToast("Name is required");
      return;
    }

    // Format numerical fields cleanly before sending
    const payload = {
      ...form,
      country_id: form.country_id ? parseInt(form.country_id) : null,
      state_id: form.state_id ? parseInt(form.state_id) : null,
      city_id: form.city_id ? parseInt(form.city_id) : null,
      waad_id: form.waad_id ? parseInt(form.waad_id) : null,
      gaon_id: form.gaon_id ? parseInt(form.gaon_id) : null,
      tehsil_id: form.tehsil_id ? parseInt(form.tehsil_id) : null,
      marrige_year: form.marrige_year ? parseInt(form.marrige_year) : null,
      anual_income: form.anual_income && !isNaN(parseFloat(form.anual_income)) ? parseFloat(form.anual_income) : null,
    };

    try {
      await updateUser({ id, ...payload }).unwrap();
      successToast("User updated successfully!");
      navigate(isPariwar ? `/pariwar-view/${id}` : `/sadasya-view/${id}`);
    } catch (err) {
      errorToast(err?.data?.message || "Update failed");
    }
  };

  // ==========================================
  // ✅ 6. HELPER: Extract Arrays from API
  // ==========================================
  const extractArray = (data) => {
    if (!data) return [];
    if (data.data && Array.isArray(data.data)) return data.data;
    if (Array.isArray(data)) return data;
    return [];
  };

  const gotraList = extractArray(gotraData);
  const waadList = extractArray(waadData);
  const gaonList = gaonData?.data?.gaons || [];

  // ==========================================
  // ✅ 7. LOADING STATE
  // ==========================================
  if (userLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <FaSpinner className="spinner-border text-primary" size={40} />
        <h5>Loading User Data...</h5>
      </div>
    );
  }

  return (
    <div className="edit-user-page">
      {/* ========== HEADER ========== */}
      <div className="d-md-flex d-block align-items-center justify-content-between my-4">
        <div>
          <h4 className="fw-semibold">Edit {isPariwar ? 'Family' : 'Member'} (ID: {id})</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            <li className="breadcrumb-item"><Link to="/admin-list">Admin List</Link></li>
            <li className="breadcrumb-item active">Edit User</li>
          </ol>
        </div>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          <FaArrowLeft className="me-2" /> Back
        </button>
      </div>

      {/* ========== FORM ========== */}
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

              {/* ====================
                  PERSONAL DETAILS
                  ==================== */}
              <div className="col-12">
                <h5 className="text-danger border-bottom pb-2">
                  <FaUser className="me-2" /> Personal Details
                </h5>
              </div>

              <div className="col-md-4">
                <label>Full Name <span className="text-danger">*</span></label>
                <input type="text" className="form-control" name="name" value={form.name} onChange={handleChange} required />
              </div>
              <div className="col-md-4">
                <label>Email</label>
                <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Mobile <span className="text-danger">*</span></label>
                <input type="text" className="form-control" name="mobile" value={form.mobile} onChange={handleChange} maxLength="10" />
              </div>

              <div className="col-md-4">
                <label>WhatsApp</label>
                <input type="text" className="form-control" name="wp_number" value={form.wp_number} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Gender</label>
                <select className="form-control" name="gender" value={form.gender} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Date of Birth</label>
                <input type="date" className="form-control" name="dob" value={form.dob} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label>Marital Status</label>
                <select className="form-control" name="marrige_status" value={form.marrige_status} onChange={handleChange}>
                  <option value="Unmarried">Unmarried</option>
                  <option value="Married">Married</option>
                  <option value="Divorced">Divorced</option>
                  <option value="Widowed">Widowed</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Marriage Year</label>
                <input type="number" className="form-control" name="marrige_year" value={form.marrige_year} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Blood Group</label>
                <select className="form-control" name="blood_group" value={form.blood_group} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
              </div>

              <div className="col-md-4">
                <label>Relation</label>
                <select className="form-control" name="relations" value={form.relations} onChange={handleChange}>
                  <option value="Head">Head</option>
                  <option value="Spouse">Spouse</option>
                  <option value="Son">Son</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Brother">Brother</option>
                  <option value="Sister">Sister</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="col-md-4">
                <label>Aadhar Number</label>
                <input type="text" className="form-control" name="aadhar_number" value={form.aadhar_number} onChange={handleChange} maxLength="12" />
              </div>

              {/* ====================
                  FAMILY & GOTRA (DYNAMIC)
                  ==================== */}
              <div className="col-12 mt-3">
                <h5 className="text-danger border-bottom pb-2">
                  <FaTree className="me-2" /> Family & Gotra Details
                </h5>
              </div>

              <div className="col-md-4">
                <label>Father's Name</label>
                <input type="text" className="form-control" name="father_name" value={form.father_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Mother's Name</label>
                <input type="text" className="form-control" name="mother_name" value={form.mother_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Mother's Gotra</label>
                <select className="form-control" name="mother_gotra" value={form.mother_gotra} onChange={handleChange}>
                  <option value="">Select</option>
                  {gotraList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gotra_name || item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label>Dada (Grandfather)</label>
                <input type="text" className="form-control" name="dada_name" value={form.dada_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Dadi (Grandmother)</label>
                <input type="text" className="form-control" name="dadi_name" value={form.dadi_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Dadi's Gotra</label>
                <select className="form-control" name="dadi_gotra" value={form.dadi_gotra} onChange={handleChange}>
                  <option value="">Select</option>
                  {gotraList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gotra_name || item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label>Nana (Maternal Grandfather)</label>
                <input type="text" className="form-control" name="nana_name" value={form.nana_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Nani (Maternal Grandmother)</label>
                <input type="text" className="form-control" name="nani_name" value={form.nani_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Nani's Gotra</label>
                <select className="form-control" name="nani_gotra" value={form.nani_gotra} onChange={handleChange}>
                  <option value="">Select</option>
                  {gotraList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gotra_name || item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label>Self Gotra</label>
                <select className="form-control" name="self_gotra" value={form.self_gotra} onChange={handleChange}>
                  <option value="">Select</option>
                  {gotraList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gotra_name || item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label>Rishi Pravar Gotra</label>
                <select className="form-control" name="rishi_pravar_gotra" value={form.rishi_pravar_gotra} onChange={handleChange}>
                  <option value="">Select</option>
                  {gotraList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gotra_name || item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label>Sadasya Gotra</label>
                <select className="form-control" name="sadasya_gotra" value={form.sadasya_gotra} onChange={handleChange}>
                  <option value="">Select</option>
                  {gotraList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.gotra_name || item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* ====================
                  PROFESSIONAL
                  ==================== */}
              <div className="col-12 mt-3">
                <h5 className="text-danger border-bottom pb-2">
                  <FaBriefcase className="me-2" /> Professional Details
                </h5>
              </div>

              <div className="col-md-4">
                <label>Education</label>
                <input type="text" className="form-control" name="education" value={form.education} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Business / Occupation</label>
                <input type="text" className="form-control" name="business" value={form.business} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Job Position</label>
                <input type="text" className="form-control" name="job_position" value={form.job_position} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Department</label>
                <input type="text" className="form-control" name="department" value={form.department} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Posted Place</label>
                <input type="text" className="form-control" name="posted_place" value={form.posted_place} onChange={handleChange} />
              </div>
              <div className="col-md-12">
                <label>Working Address</label>
                <textarea className="form-control" name="working_address" value={form.working_address} onChange={handleChange} rows="2" />
              </div>
              <div className="col-md-4">
                <label>Annual Income</label>
                <input type="text" className="form-control" name="anual_income" value={form.anual_income} onChange={handleChange} />
              </div>

              {/* ====================
                  ADDRESS (DYNAMIC WAAD & GAON)
                  ==================== */}
              <div className="col-12 mt-3">
                <h5 className="text-danger border-bottom pb-2">
                  <FaMapMarkerAlt className="me-2" /> Address Details
                </h5>
              </div>

              <div className="col-md-4">
                <label>Country</label>
                <input type="text" className="form-control" name="country_name" value={form.country_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>State</label>
                <input type="text" className="form-control" name="state_name" value={form.state_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>City / District</label>
                <input type="text" className="form-control" name="city_name" value={form.city_name} onChange={handleChange} />
              </div>

              {/* 🟢 DYNAMIC WAAD DROPDOWN */}
              <div className="col-md-4">
                <label>Waad (Ward)</label>
                <select 
                  className="form-control" 
                  name="waad_id" 
                  value={form.waad_id} 
                  onChange={handleChange}
                  disabled={waadLoading}
                >
                  <option value="">Select Waad</option>
                  {waadList.map((waad) => (
                    <option key={waad.id} value={waad.id}>
                      {waad.waad_name}
                    </option>
                  ))}
                </select>
                {waadLoading && <small className="text-muted">Loading waads...</small>}
              </div>

              {/* 🟢 DYNAMIC GAON DROPDOWN (Depends on Waad) */}
              <div className="col-md-4">
                <label>Gaon (Village)</label>
                <select 
                  className="form-control" 
                  name="gaon_id" 
                  value={form.gaon_id} 
                  onChange={handleChange}
                  disabled={!selectedWaadId || gaonLoading}
                >
                  <option value="">Select Gaon</option>
                  {gaonList.map((gaon) => (
                    <option key={gaon.id} value={gaon.id}>
                      {gaon.gaon_name}
                    </option>
                  ))}
                </select>
                {gaonLoading && <small className="text-muted">Loading gaons...</small>}
              </div>

              <div className="col-md-4">
                <label>Tehsil</label>
                <input type="text" className="form-control" name="tehsil_name" value={form.tehsil_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Village Name</label>
                <input type="text" className="form-control" name="village_name" value={form.village_name} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Ward Number</label>
                <input type="text" className="form-control" name="ward_name_number" value={form.ward_name_number} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Pin Code</label>
                <input type="text" className="form-control" name="pin_code" value={form.pin_code} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>Native Village</label>
                <input type="text" className="form-control" name="native_village" value={form.native_village} onChange={handleChange} />
              </div>
              <div className="col-md-12">
                <label>International Address</label>
                <textarea className="form-control" name="international_address" value={form.international_address} onChange={handleChange} rows="2" />
              </div>

              {/* ====================
                  IN-LAW (SASURAL)
                  ==================== */}
              {form.gender === 'Female' && form.marrige_status === 'Married' && (
                <>
                  <div className="col-12 mt-3">
                    <h5 className="text-danger border-bottom pb-2">
                      <FaHeart className="me-2" /> In-Law (Sasural) Details
                    </h5>
                  </div>
                  <div className="col-md-4">
                    <label>Husband's Name</label>
                    <input type="text" className="form-control" name="husband_name" value={form.husband_name} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Father-in-Law</label>
                    <input type="text" className="form-control" name="father_in_law_name" value={form.father_in_law_name} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Mother-in-Law</label>
                    <input type="text" className="form-control" name="mother_in_law_name" value={form.mother_in_law_name} onChange={handleChange} />
                  </div>
                  <div className="col-md-12">
                    <label>Father's Address (Pihar / Maayka)</label>
                    <textarea className="form-control" name="father_address" value={form.father_address} onChange={handleChange} rows="2" />
                  </div>
                </>
              )}

              {/* ====================
                  BUTTONS
                  ==================== */}
              <div className="col-12 mt-4 text-end">
                <button type="button" className="btn btn-secondary me-2" onClick={() => navigate(-1)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={isUpdating}>
                  {isUpdating ? (
                    <><FaSpinner className="spinner-border spinner-border-sm me-2" /> Updating...</>
                  ) : (
                    <><FaSave className="me-2" /> Save Changes</>
                  )}
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditUser;